import React from 'react'
import { Grid, Box } from '@mui/material'
import useStyles from './Styles'
import Image from 'next/image'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { RecentPressI } from 'src/types/store/index'
import { getCookie } from 'cookies-next'
interface Props {
  zenMode: boolean
  campaignPartnerData: RecentPressI[]
}
export default function Matrix({ zenMode, campaignPartnerData }: Props) {
  const { classes } = useStyles()
  const theme = useTheme()
  const greaterThanSm = useMediaQuery(theme.breakpoints.up('sm'))
  const greaterThanMd = useMediaQuery(theme.breakpoints.up('md'))
  const isBrowser = typeof window === 'object' ? true : false
  const lang = getCookie('lang')
  const filteredLogos = campaignPartnerData.map((item) => {
    return {
      height: item.attributes.logo.data.attributes.height,
      width: item.attributes.logo.data.attributes.width,
      url: item.attributes.logo.data.attributes.url,
    }
  })

  const [matrixLogos, setMatrixLogos] = React.useState([
    [...filteredLogos.slice(0, 5)],
    [...filteredLogos.slice(5, 10)],
    [...filteredLogos.slice(10, 15)],
  ])
  const campaignPartnersMx = [
    'Colaboraciones y socios',
    'Colaboraciones y socios',
    'Colaboraciones y socios',
    'Colaboraciones y socios',
    'Colaboraciones y socios',
    'Colaboraciones y socios',
  ]
  const campaignPartners =
    isBrowser && lang === 'En'
      ? [
          'CAMPAIGN PARTNERS',
          'CAMPAIGN PARTNERS',
          'CAMPAIGN PARTNERS',
          'CAMPAIGN PARTNERS',
          'CAMPAIGN PARTNERS',
          'CAMPAIGN PARTNERS',
        ]
      : campaignPartnersMx

  React.useEffect(() => {
    if (!greaterThanMd) {
      setMatrixLogos([
        [...filteredLogos.slice(0, 4)],
        [...filteredLogos.slice(4, 8)],
        [...filteredLogos.slice(8, 12)],
      ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [greaterThanMd, greaterThanSm])
  return (
    <div>
      <div className={classes.root}>
        <Box>
          <ul className={classes.headlineWrapper}>
            {[...campaignPartners, ...campaignPartners].map((item, idx) => {
              return (
                <li
                  className={`${classes.headline} ${
                    zenMode && classes.zenColor
                  }`}
                  key={idx}
                >
                  {item}
                </li>
              )
            })}
          </ul>
        </Box>

        <div className={classes.outerContainer}>
          <div className={classes.campaignsContainer}>
            <Grid container>
              <table className={classes.table}>
                <thead>
                  <tr className="row">
                    {matrixLogos[0].map((_item, idx) => {
                      return <td className={classes.outerCell} key={idx}></td>
                    })}
                  </tr>
                </thead>
                <tbody className="table-body">
                  {matrixLogos.map((item, idx) => {
                    return (
                      <tr key={idx}>
                        {item.map((item, idx) => {
                          return (
                            <td className={classes.cell} key={idx}>
                              <Image
                                src={item.url}
                                alt="image"
                                width={
                                  // !greaterThanMd
                                  //   ? !greaterThanSm
                                  //     ? 60
                                  //     : 100
                                  //   :
                                  180
                                }
                                height={70}
                                aria-label="brand logo"
                              />
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                  <tr className="row">
                    {matrixLogos[0].map((_item, idx) => {
                      return <td className={classes.outerCell} key={idx}></td>
                    })}
                  </tr>
                </tbody>
              </table>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  )
}
